import { ARRIVALS_TOUR_STEPS } from "@/lib/tours/arrivalsTour";
import { BOOKINGS_TOUR_STEPS } from "@/lib/tours/bookingsTour";
import { DASHBOARD_TOUR_STEPS } from "@/lib/tours/dashboardTour";
import { DEPARTURES_TOUR_STEPS } from "@/lib/tours/departuresTour";
import { GUESTS_TOUR_STEPS } from "@/lib/tours/guestsTour";
import { POS_TOUR_STEPS } from "@/lib/tours/posTour";
import { SHELL_TOUR_STEPS } from "@/lib/tours/shellTour";
import { SITE_PLAN_TOUR_STEPS } from "@/lib/tours/sitePlanTour";
import type { TourDefinition, TourId } from "@/lib/tours/types";

export const TOUR_DEFINITIONS: Record<TourId, TourDefinition> = {
  shell: {
    id: "shell",
    title: "App-Überblick",
    steps: SHELL_TOUR_STEPS,
    autoStart: true,
  },
  dashboard: {
    id: "dashboard",
    title: "Dashboard",
    steps: DASHBOARD_TOUR_STEPS,
    autoStart: true,
  },
  arrivals: {
    id: "arrivals",
    title: "Anreisen",
    steps: ARRIVALS_TOUR_STEPS,
  },
  departures: {
    id: "departures",
    title: "Abreisen",
    steps: DEPARTURES_TOUR_STEPS,
  },
  bookings: {
    id: "bookings",
    title: "Buchungen",
    steps: BOOKINGS_TOUR_STEPS,
  },
  guests: {
    id: "guests",
    title: "Gäste",
    steps: GUESTS_TOUR_STEPS,
  },
  "site-plan": {
    id: "site-plan",
    title: "Platzplan",
    steps: SITE_PLAN_TOUR_STEPS,
  },
  pos: {
    id: "pos",
    title: "Schnellverkauf",
    steps: POS_TOUR_STEPS,
  },
};

const ROUTE_TOUR_MAP: Array<{ match: (pathname: string) => boolean; tourId: TourId }> = [
  { match: (p) => p === "/", tourId: "dashboard" },
  { match: (p) => p === "/arrivals", tourId: "arrivals" },
  { match: (p) => p === "/departures", tourId: "departures" },
  { match: (p) => p.startsWith("/bookings"), tourId: "bookings" },
  { match: (p) => p === "/guests", tourId: "guests" },
  { match: (p) => p === "/platzplan", tourId: "site-plan" },
  { match: (p) => p === "/pos", tourId: "pos" },
];

export function tourIdForPathname(pathname: string): TourId | null {
  const entry = ROUTE_TOUR_MAP.find(({ match }) => match(pathname));
  return entry?.tourId ?? null;
}

export function getTourDefinition(tourId: TourId): TourDefinition {
  return TOUR_DEFINITIONS[tourId];
}

export const ALL_TOUR_IDS = Object.keys(TOUR_DEFINITIONS) as TourId[];
